import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaBrain, FaBolt, FaFlask, FaMemory, FaWater, FaHandRock,
  FaGraduationCap, FaHospital, FaStar, FaMicroscope, FaCalendarAlt,
  FaUniversity, FaStethoscope, FaHandshake, FaShieldAlt, FaArrowRight,
  FaPhone, FaCheckCircle, FaUserMd, FaAward
} from 'react-icons/fa';
import { MdBiotech, MdPsychology } from 'react-icons/md';
import { GiBrain } from 'react-icons/gi';
import bannerImg from '../assets/banner.jpg';
import doctorImg from '../assets/Doctor.jpg';

const quickServices = [
  { icon: <GiBrain size={28} />,       title: 'Stroke & Cerebrovascular', desc: 'Acute stroke diagnosis and thrombolysis therapy.' },
  { icon: <FaBolt size={26} />,         title: 'Epilepsy & Seizures',      desc: 'EEG-guided evaluation and long-term management.' },
  { icon: <FaFlask size={26} />,        title: 'Movement Disorders',       desc: "Parkinson's, tremors and dystonia treatment." },
  { icon: <MdPsychology size={30} />,   title: 'Memory & Dementia',        desc: "Alzheimer's and cognitive decline assessment." },
  { icon: <FaWater size={26} />,        title: 'Headache & Migraine',      desc: 'Evidence-based chronic migraine care.' },
  { icon: <FaHandRock size={26} />,     title: 'Neuropathy',               desc: 'Nerve conduction studies and pain management.' },
];

const conditions = [
  'Stroke', 'Epilepsy', "Parkinson's", 'Migraine', 'Dementia',
  'Neuropathy', 'Multiple Sclerosis', 'Sleep Disorders',
  'Neuro-infections', 'EEG / NCS / EMG', 'Neuro-critical Care', 'Movement Disorders',
];

const steps = [
  { num: '01', title: 'Book Appointment',    desc: 'Call us or fill the online form to reserve your slot.' },
  { num: '02', title: 'Consultation',        desc: 'Meet Dr. Naik for a thorough neurological examination.' },
  { num: '03', title: 'Diagnosis & Reports', desc: 'Receive precise diagnosis backed by advanced tests.' },
  { num: '04', title: 'Treatment Plan',      desc: 'Get a personalised, evidence-based care plan.' },
];

const testimonials = [
  { name: 'Priya Sharma',   loc: 'Pune',   initials: 'PS', text: "Dr. Naik diagnosed my mother's rare neurological condition when others couldn't. His knowledge and compassion are truly exceptional.", rating: 5 },
  { name: 'Rajesh Patil',   loc: 'Nashik', initials: 'RP', text: 'I suffered from severe migraines for years. After two consultations with Dr. Naik, I finally have a plan that works. Life-changing.', rating: 5 },
  { name: 'Sneha Deshmukh', loc: 'Pune',   initials: 'SD', text: "My father had a stroke and Dr. Naik's precise treatment helped him recover faster than expected. He explained everything clearly.", rating: 5 },
];

const faqs = [
  { q: 'What conditions does Dr. Naik treat?',                       a: "Dr. Naik treats all neurological conditions including stroke, epilepsy, Parkinson's disease, migraines, dementia, neuropathy, multiple sclerosis, and more." },
  { q: 'When should I consult a neurologist?',                       a: 'You should consult a neurologist if you experience: Frequent headaches or migraines, Sudden weakness or numbness, Seizures or blackouts, Memory loss or confusion, Persistent dizziness or balance issues' },
  { q: 'Is Dr. Naik available for emergencies?',                     a: 'Yes. Dr. Naik is available on call for neurological emergencies. Please contact the clinic for urgent cases.' },
  { q: 'What makes Dr. Rahul Naik’s treatment approach unique?',      a: 'Dr. Rahul Naik focuses on: Accurate diagnosis, Personalized treatment plans, Patient education, Compassionate care' },
  { q: 'Does the clinic perform EEG and NCS/EMG?',                   a: 'Yes. EEG, Nerve Conduction Studies (NCS), and EMG are all available in-clinic for comprehensive neurological evaluation.' },
];

const Home = () => {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <div className="home-page">

      {/* ── HERO with banner image ── */}
      <section className="hero hero-banner">
        {/* Banner image fills right side */}
        <div className="hero-banner-img-wrap">
          <img src={bannerImg} alt="Neurology" className="hero-banner-img" />
          <div className="hero-banner-overlay" />
        </div>

        <div className="hero-content hero-banner-content">
          <div className="hero-text">
            <div className="hero-badge">Neurology Specialist · AIIMS Trained</div>
            <h1 className="hero-title">
              Dr Rahul Naik | Expert Neurology & Brain Care
              <span className="hero-title-accent"> in Nashik</span><br/>
              
            </h1>
            <p className="hero-subtitle">
              Led by Dr. Rahul Naik — AIIMS-trained DM Neurologist with advanced
              super-specialist expertise in all neurological conditions.
            </p>
            <div className="hero-actions">
              <button className="btn-primary" onClick={() => navigate('/contact')}>Book Appointment</button>
              <button className="btn-secondary" onClick={() => navigate('/services')}>
                Our Services <FaArrowRight size={12} style={{ marginLeft: 6 }} />
              </button>
            </div>
            
          </div>
        </div>
      </section>

      

      {/* ── ABOUT SNAPSHOT ── */}
      <section className="home-about">
        <div className="container">
          <div className="home-about-grid">
            <div className="home-about-photo">
              <img src={doctorImg} alt="Dr. Rahul Naik" className="doctor-photo" />
            </div>
            <div className="home-about-text">
              <div className="section-tag">Meet the Doctor</div>
              <h2 className="section-title" style={{ textAlign: 'left' }}>Dr. Rahul Naik</h2>
              <div className="about-degrees-inline" style={{ marginBottom: 20 }}>
                <span className="degree-pill pill-amber">MBBS (BJMC, Pune)</span>
                <span className="degree-pill pill-teal">MD Internal Medicine</span>
                <span className="degree-pill pill-dark">DM Neurology (AIIMS)</span>
              </div>
              <p style={{ fontSize: 15.5, color: 'var(--text-mid)', lineHeight: 1.8, marginBottom: 20 }}>
                Dr. Rahul Naik is a super-specialist neurologist trained at India's most prestigious
                medical institution — AIIMS. With a DM in Neurology and over a decade of
                clinical experience, he brings world-class expertise to every patient at Naik Neuro Clinic, Nashik.
              </p>
              <p style={{ fontSize: 15.5, color: 'var(--text-mid)', lineHeight: 1.8, marginBottom: 32 }}>
                Known for his patient-first philosophy, Dr. Naik combines rigorous scientific knowledge
                with deep compassion — ensuring each patient receives a precise diagnosis and a
                personalised, evidence-based treatment plan.
              </p>
              <div className="home-about-chips">
                {['Stroke Expert', 'Epilepsy Care', 'Movement Disorders', 'Neuro-diagnostics', 'Migraine Specialist', 'Memory Clinic'].map(c => (
                  <span key={c} className="about-chip">{c}</span>
                ))}
              </div>
              <div style={{ marginTop: 32, display: 'flex', gap: 14, flexWrap: 'wrap' }}>
                <button className="btn-primary" onClick={() => navigate('/about')}>View Profile <FaArrowRight size={11} style={{ marginLeft: 6 }} /></button>
                <button className="btn-secondary" onClick={() => navigate('/contact')}>Book Consultation</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── TRUST BAR ── */}
      <section className="trust-bar">
        <div className="container">
          <div className="trust-bar-grid">
            {[
              { icon: <FaGraduationCap size={22} />, label: 'AIIMS',         sub: 'DM Neurology' },
              { icon: <FaHospital size={20} />,      label: 'Naik Neuro Clinic',   sub: 'Nashik, Maharashtra' },
              { icon: <FaStar size={20} />,          label: '5000+ Patients',       sub: 'Successfully Treated' },
              { icon: <FaMicroscope size={20} />,    label: 'In-Clinic EEG & NCS', sub: 'Advanced Diagnostics' },
              { icon: <FaCalendarAlt size={19} />,   label: 'Mon – Sat',            sub: '10am–2pm · 5pm–8pm' },
            ].map(({ icon, label, sub }) => (
              <div key={label} className="trust-item">
                <span className="trust-icon">{icon}</span>
                <div>
                  <div className="trust-label">{label}</div>
                  <div className="trust-sub">{sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>



      {/* ── SERVICES PREVIEW ── */}
      <section className="home-services">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">What We Treat</div>
            <h2 className="section-title">Neurology Services</h2>
            <p className="section-desc">Comprehensive care for all brain and nervous system conditions — diagnosis, treatment and long-term management.</p>
          </div>
          <div className="services-grid">
            {quickServices.slice(0, 3).map(s => (
              <div key={s.title} className="service-card">
                <div className="service-card-icon">{s.icon}</div>
                <h3 className="service-card-title">{s.title}</h3>
                <p className="service-card-desc">{s.desc}</p>
                <div className="service-card-tag">Neurology</div>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 36 }}>
            <button className="btn-primary" onClick={() => navigate('/services')}>View All 12 Services <FaArrowRight size={12} style={{ marginLeft: 6 }} /></button>
          </div>
        </div>
      </section>

      {/* ── CONDITIONS TREATED ── */}
      <section className="conditions-section">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">Conditions</div>
            <h2 className="section-title">We Treat All Neurological Conditions</h2>
            <p className="section-desc">From common headaches to complex rare disorders — expert neurological care under one roof.</p>
          </div>
          <div className="conditions-grid">
            {conditions.map(c => (
              <div key={c} className="condition-pill">
                <span className="condition-dot" />
                {c}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHY CHOOSE US ── */}
      <section className="home-why">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">Why Choose Us</div>
            <h2 className="section-title why-title">Trusted by Thousands in Nashik</h2>
            <p className="section-desc" style={{ color: 'rgba(255,255,255,0.65)' }}>What sets Naik Neuro Clinic apart from the rest.</p>
          </div>
          <div className="reasons-grid">
            {[
              { icon: <FaUniversity size={28} />, title: 'AIIMS-Trained Neurologist',  desc: "DM Neurology from India's most prestigious institution — the highest neurological qualification available." },
              { icon: <FaMicroscope size={28} />, title: 'Advanced Diagnostics',        desc: 'EEG, NCS/EMG, and neuroimaging interpretation all available under one roof.' },
              { icon: <FaHandshake size={28} />,  title: 'Patient-First Approach',      desc: "Compassionate, evidence-based care tailored to each patient's unique neurological condition." },
              { icon: <FaAward size={28} />,      title: 'Super-Specialist Care',       desc: 'Triple qualification — MBBS, MD, and DM — ensuring the highest level of neurological expertise.' },
            ].map(r => (
              <div key={r.title} className="reason-card">
                <div className="reason-icon">{r.icon}</div>
                <h3 className="reason-title">{r.title}</h3>
                <p className="reason-desc">{r.desc}</p>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 40 }}>
            <button className="btn-why-more" onClick={() => navigate('/about')}>Learn More About Us <FaArrowRight size={12} style={{ marginLeft: 6 }} /></button>
          </div>
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section className="how-it-works">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">Simple Process</div>
            <h2 className="section-title">How It Works</h2>
            <p className="section-desc">Getting expert neurological care at Naik Neuro Clinic is simple and straightforward.</p>
          </div>
          <div className="steps-grid">
            {steps.map((s, i) => (
              <div key={s.num} className="step-card">
                <div className="step-num">{s.num}</div>
                <h3 className="step-title">{s.title}</h3>
                <p className="step-desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── TESTIMONIALS ── */}
      <section className="home-testimonials">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">Patient Stories</div>
            <h2 className="section-title">What Our Patients Say</h2>
          </div>
          <div className="home-testimonials-grid">
            {testimonials.map((t, i) => (
              <div key={i} className={`testimonial-card-white ${i === 1 ? 'tcard-featured' : ''}`}>
                <div className="testimonial-stars" style={{ color: 'var(--amber)', display: 'flex', gap: 3 }}>
                  {Array.from({ length: t.rating }).map((_, si) => <FaStar key={si} size={14} />)}
                </div>
                <p className="tcard-text">"{t.text}"</p>
                <div className="testimonial-author-row">
                  <div className="testimonial-avatar">{t.initials}</div>
                  <div>
                    <div className="testimonial-name">{t.name}</div>
                    <div className="testimonial-loc">{t.loc}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 36 }}>
            <button className="btn-secondary" onClick={() => navigate('/testimonials')}>Read All Reviews <FaArrowRight size={12} style={{ marginLeft: 6 }} /></button>
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section className="home-faq">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">FAQ</div>
            <h2 className="section-title">Frequently Asked Questions</h2>
            <p className="section-desc">Quick answers to common questions about our clinic and services.</p>
          </div>
          <div className="faq-list">
            {faqs.map((f, i) => (
              <div key={i} className={`faq-item ${openFaq === i ? 'open' : ''}`}>
                <button className="faq-question" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                  <span>{f.q}</span>
                  <span className="faq-icon">{openFaq === i ? '−' : '+'}</span>
                </button>
                {openFaq === i && <div className="faq-answer">{f.a}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA BANNER ── */}
      <section className="cta-banner">
        <div className="container">
          <div className="cta-inner">
            <div className="cta-text">
              <h2 className="cta-title">Ready to Get Expert Neurological Care?</h2>
              <p className="cta-sub">Schedule your consultation with Dr. Rahul Naik today. Available Mon–Sat, Morning & Evening.</p>
            </div>
            <div className="cta-actions">
              <button className="cta-btn-primary" onClick={() => navigate('/contact')}>Book Appointment</button>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;
